/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DietaryTargetsRequest } from '../model';
// @ts-ignore
import { PauseSubscriptionRequest } from '../model';
// @ts-ignore
import { SubscriptionConflictResponse } from '../model';
// @ts-ignore
import { SubscriptionResponse } from '../model';
// @ts-ignore
import { UpdateSubscriptionActionRequest } from '../model';
/**
 * SubscriptionControllerApi - axios parameter creator
 * @export
 */
export const SubscriptionControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription: async (subscriptionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('cancelSubscription', 'subscriptionId', subscriptionId)
            const localVarPath = `/subscriptions/{subscriptionId}/cancel`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {string} subscriptionStartDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConflicts: async (planOptionId: string, subscriptionStartDate: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'planOptionId' is not null or undefined
            assertParamExists('checkConflicts', 'planOptionId', planOptionId)
            // verify required parameter 'subscriptionStartDate' is not null or undefined
            assertParamExists('checkConflicts', 'subscriptionStartDate', subscriptionStartDate)
            const localVarPath = `/subscriptions/check-conflicts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (planOptionId !== undefined) {
                localVarQueryParameter['planOptionId'] = planOptionId;
            }

            if (subscriptionStartDate !== undefined) {
                localVarQueryParameter['subscriptionStartDate'] = (subscriptionStartDate as any instanceof Date) ?
                    (subscriptionStartDate as any).toISOString().substring(0,10) :
                    subscriptionStartDate;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionAction: async (subscriptionId: string, actionId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('deleteSubscriptionAction', 'subscriptionId', subscriptionId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('deleteSubscriptionAction', 'actionId', actionId)
            const localVarPath = `/subscriptions/{subscriptionId}/actions/{actionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription: async (subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('pauseSubscription', 'subscriptionId', subscriptionId)
            // verify required parameter 'pauseSubscriptionRequest' is not null or undefined
            assertParamExists('pauseSubscription', 'pauseSubscriptionRequest', pauseSubscriptionRequest)
            const localVarPath = `/subscriptions/{subscriptionId}/pause`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pauseSubscriptionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDietaryTargetsByUser: async (subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateDietaryTargetsByUser', 'subscriptionId', subscriptionId)
            // verify required parameter 'dietaryTargetsRequest' is not null or undefined
            assertParamExists('updateDietaryTargetsByUser', 'dietaryTargetsRequest', dietaryTargetsRequest)
            const localVarPath = `/subscriptions/{subscriptionId}/dietary-targets`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dietaryTargetsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionAction: async (subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscriptionId' is not null or undefined
            assertParamExists('updateSubscriptionAction', 'subscriptionId', subscriptionId)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateSubscriptionAction', 'actionId', actionId)
            // verify required parameter 'updateSubscriptionActionRequest' is not null or undefined
            assertParamExists('updateSubscriptionAction', 'updateSubscriptionActionRequest', updateSubscriptionActionRequest)
            const localVarPath = `/subscriptions/{subscriptionId}/actions/{actionId}`
                .replace(`{${"subscriptionId"}}`, encodeURIComponent(String(subscriptionId)))
                .replace(`{${"actionId"}}`, encodeURIComponent(String(actionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSubscriptionActionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SubscriptionControllerApi - functional programming interface
 * @export
 */
export const SubscriptionControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SubscriptionControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelSubscription(subscriptionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelSubscription(subscriptionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {string} subscriptionStartDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkConflicts(planOptionId: string, subscriptionStartDate: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionConflictResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkConflicts(planOptionId, subscriptionStartDate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSubscriptionAction(subscriptionId: string, actionId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSubscriptionAction(subscriptionId, actionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSubscriptions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SubscriptionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSubscriptions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pauseSubscription(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pauseSubscription(subscriptionId, pauseSubscriptionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDietaryTargetsByUser(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDietaryTargetsByUser(subscriptionId, dietaryTargetsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSubscriptionAction(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSubscriptionAction(subscriptionId, actionId, updateSubscriptionActionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SubscriptionControllerApi - factory interface
 * @export
 */
export const SubscriptionControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SubscriptionControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {string} subscriptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelSubscription(subscriptionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.cancelSubscription(subscriptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} planOptionId 
         * @param {string} subscriptionStartDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkConflicts(planOptionId: string, subscriptionStartDate: string, options?: any): AxiosPromise<SubscriptionConflictResponse> {
            return localVarFp.checkConflicts(planOptionId, subscriptionStartDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubscriptionAction(subscriptionId: string, actionId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteSubscriptionAction(subscriptionId, actionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSubscriptions(options?: any): AxiosPromise<Array<SubscriptionResponse>> {
            return localVarFp.listSubscriptions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pauseSubscription(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.pauseSubscription(subscriptionId, pauseSubscriptionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {DietaryTargetsRequest} dietaryTargetsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDietaryTargetsByUser(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateDietaryTargetsByUser(subscriptionId, dietaryTargetsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} subscriptionId 
         * @param {string} actionId 
         * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscriptionAction(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: any): AxiosPromise<void> {
            return localVarFp.updateSubscriptionAction(subscriptionId, actionId, updateSubscriptionActionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SubscriptionControllerApi - object-oriented interface
 * @export
 * @class SubscriptionControllerApi
 * @extends {BaseAPI}
 */
export class SubscriptionControllerApi extends BaseAPI {
    /**
     * 
     * @param {string} subscriptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public cancelSubscription(subscriptionId: string, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).cancelSubscription(subscriptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} planOptionId 
     * @param {string} subscriptionStartDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public checkConflicts(planOptionId: string, subscriptionStartDate: string, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).checkConflicts(planOptionId, subscriptionStartDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {string} actionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public deleteSubscriptionAction(subscriptionId: string, actionId: string, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).deleteSubscriptionAction(subscriptionId, actionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public listSubscriptions(options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).listSubscriptions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {PauseSubscriptionRequest} pauseSubscriptionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public pauseSubscription(subscriptionId: string, pauseSubscriptionRequest: PauseSubscriptionRequest, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).pauseSubscription(subscriptionId, pauseSubscriptionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {DietaryTargetsRequest} dietaryTargetsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public updateDietaryTargetsByUser(subscriptionId: string, dietaryTargetsRequest: DietaryTargetsRequest, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).updateDietaryTargetsByUser(subscriptionId, dietaryTargetsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} subscriptionId 
     * @param {string} actionId 
     * @param {UpdateSubscriptionActionRequest} updateSubscriptionActionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionControllerApi
     */
    public updateSubscriptionAction(subscriptionId: string, actionId: string, updateSubscriptionActionRequest: UpdateSubscriptionActionRequest, options?: AxiosRequestConfig) {
        return SubscriptionControllerApiFp(this.configuration).updateSubscriptionAction(subscriptionId, actionId, updateSubscriptionActionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

